import "./index.scss";
export const Loader = () => (
  <div className="lds-ring">
    <div className="lds-ring__first"></div>
    <div className="lds-ring__second"></div>
    <div className="lds-ring__third"></div>
    <div className="lds-ring__fourth"></div>
  </div>
);
